<template>
  <div 
    class="fts-contenteditable"
    :class="[
      textWrap ? 'content-wrap' : 'content-nowrap',
      {'disabled': !contenteditable}
    ]"
    :contenteditable="contenteditable"
    v-once
    v-html="value"
    :value="value"
    :spellcheck="spellcheck"
    :placeholder="placeholder"
    @input="onInput"
    @focus="onFocus"
    @blur="onBlur"
    @paste.prevent="onPaste($event)"
    @keydown.enter="onEnter($event)"
    @mousedown="onMousedown"
    tabindex="0"
  >
  </div>
</template>

<script>

let mousedownEvent = false; 

export default {
  props: {
    value: {
      type: String,
    },
    contenteditable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "Untitled"
    },
    textWrap: Boolean,
    spellcheck: Boolean,
    search: Boolean,
    multipleLine: Boolean,
    debounceTime: {
      type: Number,
      default: 800,
    },
    autofocus: Boolean,
  },
  methods: {
    onInput($event) {
      const el = $event.target;
      let val = el.innerText;

      if (!this.multipleLine) {
        val = val.replace(/\n|\r/g, "");
      }

      this.$emit('input', val);

      if (el.innerHTML === '<br>' || el.textContent.trim() === '') {
        el.innerHTML = '';
      }

      if (this.search) {
        this.debounceSearch();
      }
    },
    onFocus(evt) {
      try {
        /* autofocus last range */
        if (
          evt.relatedTarget
          && evt.target.firstChild
          && !mousedownEvent
        ) {
          let range = document.createRange();
          let selection = window.getSelection();
          range.selectNodeContents(evt.target.firstChild);
          range.setStart(evt.target.firstChild, range.endOffset);
          range.setEnd(evt.target.firstChild, range.endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        } else if (
          typeof window.getSelection != 'undefined'
          && typeof document.createRange != 'undefined'
        ) {
          let range = document.createRange();
          range.selectNodeContents(this.$el);
          range.collapse(false);
          let selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        } else if (typeof document.body.createTextRange != 'undefined') {
          let textRange = document.body.createTextRange();
          textRange.moveToElementText(this.$el);
          textRange.collapse(false);
          textRange.select();
        }
      } catch(err) {
        console.warn("[DOMException]", err);
      }
      mousedownEvent = false;
      this.$emit('input:focus');
    },
    onBlur() {
      this.$emit('input:blur');
    },
    onPaste(evt) {
      var text = evt.clipboardData.getData("text/plain");
      document.execCommand("insertHTML", false, text);
      this.$emit('input:paste');
    },
    onEnter(evt) {
      if (!this.multipleLine)
        evt.preventDefault();

      this.$emit('keydown:enter');
    },
    onMousedown() {
      mousedownEvent = true;
    },
    onSearch() {
      this.$emit('input:search');
    },
  },
  computed: {
    debounceSearch() {
      return _.debounce(this.onSearch, this.debounceTime);
    },
  },
  watch: {
    value: function (val) {
      if (document.activeElement == this.$el) return;

      if (val)
        this.$el.innerHTML = this.multipleLine ? val : val.replace(/\n|\r/g, "");
      else
        this.$el.innerHTML = "";
    }
  },
  mounted() {
    if (this.autofocus) this.$el.focus();
  },
}
</script>

<style lang="scss" scoped>
.fts-contenteditable {
  width: 100%;
  word-break: break-word;
  cursor: text;
  &:empty:before {
    content: attr(placeholder);
    -webkit-text-fill-color: inherit;
    opacity: .45;
  }
  &.content-nowrap {
    overflow: hidden;
    white-space: nowrap;
  }
  &.content-wrap {
    word-break: break-word;
  }
  &.disabled {
    cursor: default;
  }
}
</style>